import { LoginState } from 'src/modules/login/types/LoginState';
import { RootState } from 'src/types/RootState';

export function getLoginState(state: RootState): LoginState {
  return state.login;
}
